import { IconProps } from 'src/utils/icon';

const AlignLeftIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      fill={fill}
      d="M.4 10h8.2a.401.401 0 00.4-.4V8.4a.4.4 0 00-.4-.4H.4a.4.4 0 00-.4.4v1.2a.4.4 0 00.4.4zm0-8h8.2a.4.4 0 00.4-.4V.4a.4.4 0 00-.4-.4H.4a.4.4 0 00-.4.4v1.2a.4.4 0 00.4.4zm13.1 2H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm0 8H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
    />
  </svg>
);

export default AlignLeftIcon;
